import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const NoAccessRoute = LazyLoad(
  lazy(() => import('./no-access').then((module) => ({ default: module.NoAccess }))),
);
